module.exports = __webpack_public_path__ + "img/default-tablet-arabic.5dd98fe6.png";